import { useCurrentFormatCurrency } from "../../hooks/usePrices";

function SideCartTotalTieredDiscount({
  estimatedTotal,
  fullAmount,
  showLineThrough,
  hasFreeShipping,
  shippingPrice,
}) {
  const formatCurrency = useCurrentFormatCurrency();

  return (
    <p className="flex justify-between pb-[5px] desktop:pb-[8px] last:pb-0">
      {/* The key below is used to prevent a Safari-only rendering issue https://stackoverflow.com/a/55050203 */}
      {estimatedTotal < fullAmount ? (
        <span key={`sidecart_total_${estimatedTotal}`}>
          {showLineThrough ? (
            <span className="flex items-center">
              <span className="strikethrough strikethrough--bold">
                {formatCurrency(fullAmount)}
              </span>
              <span className="ml-[5px] desktop:ml-[6px]">{formatCurrency(estimatedTotal)}</span>
            </span>
          ) : (
            formatCurrency(estimatedTotal)
          )}
        </span>
      ) : (
        <span key={`classic_${fullAmount}`}>
          {formatCurrency(hasFreeShipping ? estimatedTotal : fullAmount + shippingPrice)}
        </span>
      )}
    </p>
  );
}

export default SideCartTotalTieredDiscount;
